<template>
  <div class="col-12 col-lg-6">
    <div class="tit text-center">
      <h1>Cidade/UF de Nascimento</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit.prevent="onSubmit">
          <div class="form-group text-left">
            <label for="estado">Estado</label>
            <at-select v-model="uf" filterable size="large" placeholder="Estado" @on-change="onUfChange">
              <at-option v-for="(state, i) in estados" :key="`stateOptions${i}`" :value="state.uf">{{state.nome}}</at-option>
            </at-select>
          </div>
          <div class="form-group text-left">
            <label for="cidade">Cidade</label>
            <at-select ref="citySelect" v-model="currentUser.Pessoal.CidadeOrigem" filterable size="large" :disabled="estaCidadeDesabilitado" placeholder="Cidade">
              <at-option v-for="(city, i) in cidades" :key="`cityOptions${i}`" :value="city.nome">{{city.nome}}</at-option>
            </at-select>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary" type="submit">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select"
import HubConsultaClient from '../../utils/hub-consulta-client';
import StringHelper from '@/utils/string-helper'

export default {
/* eslint-disable */
  components: {
    vSelect
  },
  data() {
    const origem = this.currentUser.Pessoal
    return {
      uf: origem ? origem.EstadoOrigem: null,
      cidade: origem ? origem.CidadeOrigem: "",
      estados: [],
      cidades: []
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  computed: {
    estaCidadeDesabilitado: function() { return this.cidades.length == 0 },
  },
  methods: {
    onUfChange() {
      this.cidades = []
      if(!this.uf) {
        this.cidade = ''
        return
      }
      HubConsultaClient.pegarCidades(this.uf)
        .then(cidades => {
          this.cidades = cidades
          this.$refs.citySelect.$el.children[0].children[2].required = true;

          if(this.cidade) {
            this.setCity()
          }
        })
    },
    setCity() {
      const city = this.cidades.find(city => {
        return StringHelper.removeAccents(city.nome.toUpperCase()) == StringHelper.removeAccents(this.cidade.toUpperCase())
      })
      if(!city) {
        this.cidade = ''
      } else {
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        this.cidade = ''
        setTimeout(() => this.cidade = city.nome, 100)
      }
    },
    onSubmit(e) {
      e.preventDefault()
      
      this.currentUser.Pessoal.EstadoOrigem = this.uf;

      this.$emit('on-submit', {Pessoal: this.currentUser.Pessoal})
    }
  },
  created() {
    HubConsultaClient.pegarEstados()
      .then(estados => {
        this.estados = estados
        // When the city state is seted before cities is populated the component doesn't show
        // the selected city.
        const uf = this.uf
        const city = this.cidade
        this.uf = ''
        
        setTimeout(() => {
          this.uf = uf
          this.cidade = city
        }, 100)
      })
  },
  mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");

    if(this.currentUser.Pessoal.CidadeOrigem) {
      setTimeout(() => {
        document.getElementsByClassName('at-select__input')[1].value = this.currentUser.Pessoal.CidadeOrigem;
      }, 1000);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/CityStep.vue